export default function() {
  return new Worker(__webpack_public_path__ + "cluster-worker.6bea6d62a365a4400bdc.worker.js");
}
